module.exports = __webpack_public_path__ + "static/img/454.1d369cf.png";